import React, {useState, useEffect} from 'react';
import {connect, Provider} from "react-redux";
import {getReduxStore} from "../ReduxStore/store";
import HamburgerButton from "./HamburgerButton";

function mapStateToProps(state) {
  const {navigationSlice = {}} = state;

  return navigationSlice;
}

let Wrapper = connect(mapStateToProps)(HamburgerButton);

export default function HamburgerButtonApp(props) {
  return <Provider store={getReduxStore()}>
    <Wrapper {...props} />
  </Provider>
}
